import type { God, GodName, EventType } from '../types';

// === 神仙定义（视觉字段 fallback，运行时由 GET /god-info 覆盖 desc）===
export const GODS: Record<GodName, God> = {
  xishen: {
    id: 'xishen', name: '喜神', emoji: '🎊', color: '#e63946', bgColor: '#fff3cd',
    title: '喜庆之神', desc: '掌管天下喜事，初次引路者',
  },
  caishen: {
    id: 'caishen', name: '财神', emoji: '🧧', color: '#e63946', bgColor: '#fff3cd',
    title: '财富之神', desc: '掌管天下财源，为你卡死预算',
  },
  yuelao: {
    id: 'yuelao', name: '月老', emoji: '💕', color: '#e76f51', bgColor: '#fce4ec',
    title: '姻缘之神', desc: '牵红线的好手，备婚习俗全知道',
  },
  zsnn: {
    id: 'zsnn', name: '注生娘娘', emoji: '👶', color: '#e9c46a', bgColor: '#fff8e1',
    title: '子嗣之神', desc: '送子赐福，育儿清单一手包办',
  },
  szgy: {
    id: 'szgy', name: '送子观音', emoji: '🪷', color: '#a8dadc', bgColor: '#e0f7fa',
    title: '慈悲之神', desc: '慈悲护佑，母婴安康',
  },
  wqx: {
    id: 'wqx', name: '文曲星', emoji: '📚', color: '#457b9d', bgColor: '#e3f2fd',
    title: '文运之神', desc: '金榜题名，学业祈福',
  },
  kx: {
    id: 'kx', name: '魁星', emoji: '✍️', color: '#264653', bgColor: '#e8eaf6',
    title: '科举之神', desc: '独占鳌头，考试必过',
  },
  zy: {
    id: 'zy', name: '灶王爷', emoji: '🍲', color: '#2a9d8f', bgColor: '#e8f5e9',
    title: '灶火之神', desc: '温锅入伙，灶火兴旺',
  },
  tdg: {
    id: 'tdg', name: '土地公', emoji: '🏡', color: '#8d99ae', bgColor: '#f5f5f5',
    title: '土地之神', desc: '乔迁选址，平安落地',
  },
};

// === 喜事类型→神仙组合矩阵（前端派生 gods，不再存进 EventProject）===
export const EVENT_TYPES: { type: EventType; label: string; title: string; gods: GodName[]; mainGod: GodName }[] = [
  { type: 'wedding', label: '新婚', title: '新婚大喜', gods: ['caishen', 'yuelao', 'zsnn'], mainGod: 'yuelao' },
  { type: 'baby', label: '添丁', title: '添丁之喜', gods: ['caishen', 'zsnn', 'szgy'], mainGod: 'zsnn' },
  { type: 'school', label: '升学', title: '升学之喜', gods: ['caishen', 'wqx', 'kx'], mainGod: 'wqx' },
  { type: 'birthday', label: '祝寿', title: '生日筹备', gods: ['caishen', 'zsnn'], mainGod: 'zsnn' },
  { type: 'move', label: '乔迁', title: '乔迁之喜', gods: ['caishen', 'zy', 'tdg'], mainGod: 'zy' },
  { type: 'business', label: '开张', title: '开张大吉', gods: ['caishen', 'zy', 'tdg'], mainGod: 'zy' },
  { type: 'festival', label: '佳节', title: '节日快乐', gods: ['caishen'], mainGod: 'caishen' },
  { type: 'other', label: '其他', title: '大喜事', gods: ['caishen'], mainGod: 'caishen' },
];

// 获取喜事标题
export function getEventTitle(type: EventType): string {
  return EVENT_TYPES.find((e) => e.type === type)?.title || '大喜事';
}

// 获取喜事主管神
export function getMainGod(type: EventType): GodName {
  return EVENT_TYPES.find((e) => e.type === type)?.mainGod || 'caishen';
}

// 获取喜事神仙组合（喜神默认拉入主管神+财神）
export function getEventGods(type: EventType): GodName[] {
  const def = EVENT_TYPES.find((e) => e.type === type);
  if (!def) return ['caishen'];
  return def.gods;
}
